import { observer } from 'mobx-react-lite';
import "./WebHomePage.css";  
import { useEffect, useState } from 'react';
import { ScrollRestoration, useLocation } from 'react-router-dom';
import ModalContainer from '../../app/common/modals/ModalContainer';
import { ToastContainer } from 'react-toastify';
import Navbar from '../../app/common/controls/Navbar';
import Content from '../../app/common/controls/Content';
import AboutUsComponent from './AboutUsComponent';
import { useStore } from '../../app/stores/rootStore';
export default observer(function AboutUsPage() {
    const { commonStore,modalStore } = useStore();
    const currentyear = new Date().getFullYear();
    const location = useLocation();
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);
    const [toggleBtn, setToggleBtn] = useState(true);
  const toggle = () => setToggleBtn(val => !val);
    return (
      <>
      <AboutUsComponent />
<section data-bs-version="5.1" className="buildm5 features3 cid-ub1nBPRwUM" id="features3-t">
  <div className="container">    
    <div className="row content-row">
      <div className="item features-without-image col-12 col-md-6 col-lg-6 item-mb">
        <div className="item-wrapper">
          <div className="title mb-3">
            <span className="num mbr-fonts-style display-7">01</span>
          </div>
          <h4 className="card-title mbr-fonts-style pb-2 display-5">Our Mission</h4>
          <p className="mbr-text card-text mbr-fonts-style mb-0 display-7">To deliver high-quality Jewels and leather products, delivering innovation, sustainability, and exceptional value to our customers. Our goal is to support brands and retailers with versatile Jewels and leather products solutions.<br/></p>
          <div className="line2"></div>
        </div>
      </div>
      <div className="item features-without-image col-12 col-md-6 col-lg-6 item-mb">
        <div className="item-wrapper">
          <div className="title mb-3">
            <span className="num mbr-fonts-style display-7">02</span>
          </div>
          <h4 className="card-title mbr-fonts-style pb-2 display-5">Quality Assurance</h4>
          <p className="mbr-text card-text mbr-fonts-style mb-0 display-7">As a trusted supplier of premium Jewels and leather products, we are committed to maintaining the highest standards of quality throughout every stage of production<br/></p>
          <div className="line2"></div>
        </div>
      </div>
      <div className="item features-without-image col-12 col-md-6 col-lg-6 item-mb">
        <div className="item-wrapper">
          <div className="title mb-3">
            <span className="num mbr-fonts-style display-7">03</span>
          </div>
          <h4 className="card-title mbr-fonts-style pb-2 display-5">Sustainable Practices</h4>
          <p className="mbr-text card-text mbr-fonts-style mb-0 display-7">As a leading Jewels and leather products supplier, we are committed to minimizing our environmental impact while producing high-quality, eco-friendly denim fabrics and garments. We are committed to reducing packaging waste by using recyclable and biodegradable packaging materials.<br/></p>
          <div className="line2"></div>
        </div>
      </div>
      <div className="item features-without-image col-12 col-md-6 col-lg-6 item-mb">
        <div className="item-wrapper">
          <div className="title mb-3">
            <span className="num mbr-fonts-style display-7">04</span>
          </div>
          <h4 className="card-title mbr-fonts-style pb-2 display-5">Customer Satisfaction</h4>
          <p className="mbr-text card-text mbr-fonts-style mb-0 display-7">We are dedicated to delivering exceptional products, services, and experiences that exceed our clients' expectations. We understand that the foundation of customer satisfaction lies in providing premium denim fabrics and garments. We welcome and actively seek feedback from our customers.<br/></p>
          <div className="line2"></div>
        </div>
      </div>


    </div>
  </div>
</section>
      </>
    )
})